import { render, staticRenderFns } from "./LocaleSwitch.vue?vue&type=template&id=0e4d7d9e"
import script from "./LocaleSwitch.vue?vue&type=script&lang=js"
export * from "./LocaleSwitch.vue?vue&type=script&lang=js"
import style0 from "./LocaleSwitch.vue?vue&type=style&index=0&id=0e4d7d9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports